import React, { FC, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { RouteComponentProps } from 'react-router-dom'
import { IonPage, IonHeader, IonContent, IonFooter, useIonViewDidEnter, IonInfiniteScroll, IonInfiniteScrollContent } from '@ionic/react'
import { UseHeader, MktEmpty, CouponItem, CouponDetail, MktButton } from '@cps'
import { memberMobx, memberCardMobx } from '@mobxStore'
import { find, each, keyBy } from '@dt/fe-utils/dist/lodash'
import { MemberApi, ActivityAPI } from 'api/index'
import { modalLayer, useHistoryNew } from '@utils'
import CouponType from '../components/CouponType'
import mktController from '@ctrls/mktController'
import './index.scss'

interface IProps extends IPage, RouteComponentProps { }

const pageSize: number = 10

const CouponGet: FC<IProps> = () => {
  const typeArr: any[] = [
    {
      label: i18n.t('mkt.coupon.unaccalimed'),
      value: 'not',
    },
    {
      label: i18n.t('mkt.coupon.received'),
      value: 'get',
    },
  ]
  const history = useHistoryNew()
  const [couponsList, setCouponsList] = useState<any[]>([])
  const [visble, setVisble] = useState<boolean>(false)
  const [typeInfo, setTypeInfo] = useState<any>(typeArr[0])
  const [page, setPage] = useState<number>(-1)
  const [canget, setCanget] = useState<boolean>(true)
  const [activeMap, setActiveMap] = useState<any>({})
  const [couponMap, setCouponMap] = useState<any>({})

  const goDetail = (data: any) => {
    modalLayer(CouponDetail, { type: 'get', couponInfo: data }, 'couponDetail')
  }

  const getCoupons = () => {
    memberMobx.acquiredCouponList().then(() => {
      history.goBack()
    })
  }

  const onScrollEnd = (ev: any) => {
    if (canget) {
      setTimeout(() => {
        setPage(page + 1)
        ev.target.complete()
      }, 500)
    }
  }

  const getData = (pageNum: number, data: any[]) => {
    const para: any = {
      brandId: memberMobx.brandId,
      memberId: memberMobx.memberInfo.memberId,
      page: page,
      limit: pageSize,
    }
    MemberApi.getAcquiredLogs(para).then((res: any) => {
      if (!res.error) {
        const showCoupons: any[] = []
        each(res.items, (item: any) => {
          const itemCoupons: any[] = []
          each(item.coupons, (child: any) => {
            for (let i = 0; i < child.couponCnt; i++) {
              itemCoupons.push({
                couponId: child.couponId,
              })
            }
          })
          const obj: any = {
            ...item,
            coupons: itemCoupons,
          }
          showCoupons.push(obj)
        })
        setCouponsList(data.concat(showCoupons))
        if (pageNum + 1 >= Math.ceil(res.meta.totalPages)) {
          setCanget(false)
        } else {
          setCanget(true)
        }
      }
    })
  }

  useIonViewDidEnter(() => {
    setTypeInfo(typeArr[0])
  })

  useEffect(() => {
    if (typeInfo.value === 'not') {
      const showCoupons: any[] = []
      each(memberMobx.unacquiredCoupons, (item: any) => {
        const itemCoupons: any[] = []
        each(item.coupons, (child: any) => {
          for (let i = 0; i < child.couponCnt; i++) {
            itemCoupons.push({
              couponId: child.couponId,
            })
          }
        })
        const obj: any = {
          ...item,
          coupons: itemCoupons,
        }
        showCoupons.push(obj)
      })
      setCouponsList(showCoupons)
    }
  }, [memberMobx.unacquiredCoupons])

  useEffect(() => {
    if (couponsList.length > 0) {
      const activeIds: number[] = []
      const couponIds: number[] = []
      each(couponsList, (item: any) => {
        if (item.type === 'activityCoupon') {
          if (item.sendType !== 'birthdayCoupon') {
            if (!activeIds.includes(parseInt(item.outId))) {
              activeIds.push(parseInt(item.outId))
            }
          }
        }
        each(item.coupons, (cItem: any) => {
          if (!couponIds.includes(cItem.couponId)) {
            couponIds.push(cItem.couponId)
          }
        })
      })
      if (activeIds.length > 0) {
        ActivityAPI.getActiveList({
          activityId: activeIds,
        }).then((res: any) => {
          if (!res.error) {
            setActiveMap(keyBy(res, 'activityId'))
          }
        })
      }
      ActivityAPI.getCouponsList({
        couponIds: couponIds
      }).then((res: any) => {
        if (!res.error) {
          setCouponMap(keyBy(res, 'couponId'))
        }
      })
    }
  }, [couponsList])

  useEffect(() => {
    if (typeInfo.value === 'not') {
      memberMobx.getUnacquiredCoupons()
      setPage(-1)
    } else {
      setPage(0)
    }
  }, [typeInfo])

  useEffect(() => {
    if (typeInfo.value === 'get') {
      getData(page, page === 0 ? [] : couponsList)
    }
  }, [page])
  return (
    <IonPage className='coupon-get-page'>
      <UseHeader onBack={() => mktController.goBack(history)} title={i18n.t('mkt.member.couponColl')}></UseHeader>
      <IonHeader>
        <div className='type-select' onClick={() => setVisble(true)}>
          <span>{typeInfo.label}</span>
          <i className='iconfont icon-chevron-down'></i>
        </div>
      </IonHeader>
      <IonContent className='page-content'>
        {couponsList.length === 0 && <MktEmpty />}
        {
          couponsList.length > 0 &&
            <div className='card-list'>
              {
                couponsList.map((item: any, index: number) => {
                  let title: string = ''
                  let des: string = ''
                  if (item.type === 'cardCouponPolicy') {
                    const findCard: any = find(memberCardMobx.allCardList, (m: any) => `${m.cardId}` === `${item.remark}`)
                    title = findCard ? findCard.cardName : i18n.t('pageName.card')
                    des = item.remark ? i18n.t('mkt.member.getCouponTip1', { time: i18n.t(`mkt.member.sendTime${item.sendValue}`), number: item.coupons.length }) : ''
                  } else if (item.type === 'activityCoupon') {
                    if (item.sendType === 'birthdayCoupon') {
                      title = i18n.t('mkt.member.birthdayCoupon')
                      des = i18n.t('mkt.member.birthdayCouponDes', { birthday: memberMobx.memberInfo.birthday })
                    } else {
                      const findActive: any = activeMap[parseInt(item.outId)]
                      title = findActive ? findActive.activityName : ''
                    }
                  } else if (item.type === 'memberCouponPolicy') {
                    title = i18n.t('mkt.member.memberCouponPolicy')
                  }
                  return (
                    <div className='coupon-area' key={index}>
                      <div className='header'>
                        <div className='title'>{title}</div>
                        <div className='des'>{des}</div>
                      </div>
                      <div className='coupon-list'>
                        {
                          item.coupons.map((coupon: any, cIndex: number) => {
                            const hasItem: any = couponMap[coupon.couponId]
                            return hasItem && (
                              <div className='coupon-block' key={`${cIndex}-${coupon.couponId}`}>
                                <CouponItem type='get' couponInfo={hasItem} onClick={goDetail}></CouponItem>
                              </div>
                            )
                          })
                        }
                      </div>
                    </div>
                  )
                })
              }
            </div>
        }
        {
          canget && typeInfo.value === 'get' &&
            <IonInfiniteScroll threshold='100px' onIonInfinite={(ev) => onScrollEnd(ev)}>
              <IonInfiniteScrollContent
                loadingSpinner='bubbles'
                loadingText={i18n.t('order.loadmore')}
              >
              </IonInfiniteScrollContent>
            </IonInfiniteScroll>
        }
      </IonContent>
      {
        memberMobx.unacquiredCoupons.length > 0 && typeInfo.value === 'not' &&
          <IonFooter>
            <div className='page-footer'>
              <MktButton text={i18n.t('mkt.member.claimAll')} onClick={getCoupons}></MktButton>
            </div>
          </IonFooter>
      }
      <CouponType
        visible={visble}
        data={typeArr}
        value={typeInfo}
        onClose={() => setVisble(false)}
        onChange={(val: any) => {
          setTypeInfo(val)
          setVisble(false)
        }}
      >
      </CouponType>
    </IonPage>
  )
}

export default observer(CouponGet)
